module.exports = __webpack_public_path__ + "img/logo_shayah.cf73a741.png";